<template>
  <div>
    <Head :title="$t('message.tickets.create_ticket')" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/tickets/tickets">
        {{ $t('message.tickets.tickets', 2) }}
      </Link>
      <span class="text-indigo-400 font-medium">/</span> {{ $t('message.general.create') }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input v-model="form.issue_id" :error="form.errors.issue_id" class="lg pb-8 pr-6 w-full" :label="$t('message.tickets.issue')">
            <option :value="null" />
            <option v-for="issue in issues" :key="issue.id" :value="issue.id">{{ issue.name }}</option>
          </select-input>
          <textarea-input v-model="form.summary" :error="form.errors.summary" class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('message.tickets.subject')" />
          <textarea-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('message.tickets.description')" />
          <div v-for="(file, index) in form.attachments.length + 1" :key="index">
            <file-input v-model="files[index]" :error="form.errors.attachments" class="pb-8 pr-6 w-full" :label="$t('message.tickets.attachment')" />
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            {{ $t('message.tickets.create_ticket') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput.vue'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    FileInput,
    TextInput,
    TextareaInput,
  },
  layout: Layout,
  props: {
    issues: Array,
    departments: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        user_id: this.$page.props.auth.user.id,
        department_id: null,
        issue_id: null,
        summary: '',
        description: '',
        attachments: [],
      }),
      files: [],
    }
  },
  watch: {
    files: {
      handler(files) {
        this.form.attachments = files.filter((file) => file != null)
        files.forEach((file, index) => {
          if (file == null) {
            this.delete(this.files, index)
          }
        })
      },
      deep: true,
    },
  },
  methods: {
    delete(items, index) {
      items.splice(index, 1)
    },
    store() {
      this.form.post('/tickets/tickets')
    },
  },
}
</script>
